import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import { setSelectedStore } from '../../../redux/modules/auth/action';
import { USER_TYPES } from '@common/src/constants/constants';
import { ALL_OPTION } from '@pulse/constants/constants';

const StoreDrop = () => {
  const dispatch = useDispatch();
  const { stores = [], loading = true, user, selectedStore } = useSelector((state) => state.auth || {});
  const currentPage = window.location.pathname;

  const isStorePage = ['/menu/', '/modifiers/', '/deliveryConfig/'].includes(currentPage);
  const options = isStorePage ? stores : [ALL_OPTION.stores, ...stores];

  useEffect(() => {
    let defaultStore;
    if (isStorePage) {
      defaultStore = selectedStore !== ALL_OPTION.stores ? selectedStore : stores[0];
    } else {
      defaultStore = ALL_OPTION.stores;
    }
    dispatch(setSelectedStore(defaultStore));
  }, [currentPage, isStorePage, stores, dispatch]);

  if (currentPage === '/store/' || currentPage === '/order-details/') return null;

  return (
    <>
      {!loading && user?.userType === USER_TYPES.PULSE_SUB_ADMIN && (
        <Select
          className="ti-form-select rounded-sm !p-0 min-w-[300px]"
          placeholder="Choose Store"
          options={options}
          value={selectedStore || options[0]}
          onChange={(obj) => dispatch(setSelectedStore(obj))}
        />
      )}
    </>
  );
};

export default StoreDrop;
